import script from "./AdTable.vue?vue&type=script&setup=true&lang=js"
export * from "./AdTable.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__